"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
var cart_service_1 = require("../services/cart.service");
var free_gifts_service_1 = require("../services/free-gifts.service");
var storefront_service_1 = require("../services/storefront.service");
var coupons_1 = require("./coupons/coupons");
var free_gifts_1 = require("./free-gifts/free-gifts");
var cross_sell_products_1 = require("./cross-sell-products/cross-sell-products");
var common_helper_1 = require("../helpers/common.helper");
var Cart = /** @class */ (function () {
    function Cart() {
        this.cartService = new cart_service_1["default"]();
        this.storefrontService = new storefront_service_1["default"]();
        this.isPageReloading = false;
        this.selectors = {
            body: 'body',
            ajaxAddToCart: '.ajax-add-to-cart',
            continueBtn: '#continue_button',
            addProductToCartForm: '.js-add-product-to-cart-form',
            addFreeGiftBtn: '.js-add-free-gift-btn',
            addProductBtn: '.js-add-product-btn',
            addSingleProductBtn: '.js-single-add-product-btn',
            cartFreeGiftsError: '.js-cart-free-gifts-error',
            giftWrapContainer: '.js-gift-wrap-container'
        };
        this.cart = {};
        this.pageType = '';
        //@ts-ignore
        this.pageType = window.pageType;
        this.init();
    }
    Cart.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 9, , 10]);
                        this.disableContinueBtn(true);
                        _a = this;
                        return [4 /*yield*/, this.cartService.get()];
                    case 1:
                        _a.cart = _b.sent();
                        this.freeGifts = new free_gifts_1["default"](this.cart);
                        this.freeGiftsService = new free_gifts_service_1["default"](this.cart);
                        this.coupons = new coupons_1["default"](this.cart);
                        this.crossSellProducts = new cross_sell_products_1["default"](this.cart);
                        this.bindEvents();
                        if (!common_helper_1.isCheckoutPage()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handleCoupons()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (this.isPageReloading) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.validateCart()];
                    case 4:
                        _b.sent();
                        if (this.isPageReloading) {
                            return [2 /*return*/];
                        }
                        if (!(this.pageType === 'cart')) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.handleFreeGifts()];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.handleCrossSellProducts()];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [4 /*yield*/, this.handleGiftWrap()];
                    case 8:
                        _b.sent();
                        this.disableContinueBtn(false);
                        return [3 /*break*/, 10];
                    case 9:
                        err_1 = _b.sent();
                        this.disableContinueBtn(true);
                        console.log(err_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.handleGiftWrap = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, settings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storefrontService.get("settings")];
                    case 1:
                        response = _a.sent();
                        settings = response.data;
                        if (!settings) {
                            return [2 /*return*/, false];
                        }
                        if (settings.giftWrapEnabled) {
                            $(this.selectors.giftWrapContainer).show();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.validateCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateCartFreeGifts()];
                    case 1:
                        _a.sent();
                        if (this.isPageReloading) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.validateCartCustomCoupon()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.validateCartCrossSellProducts()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.validateCartFreeGifts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var threshold, freeSamplesIds, gwpIds, freeGiftIds, customCouponItem, customCouponItemId, _i, freeGiftIds_1, id, _a, freeGiftIds_2, id, reloadRequired, _b, _c, cartItem, itemThreshold, line, _d, _e, cartItem, data;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.freeGiftsService.getQualifiedThreshold()];
                    case 1:
                        threshold = _f.sent();
                        freeSamplesIds = common_helper_1.getCartItemsIdByType(this.cart, 'Sample');
                        gwpIds = common_helper_1.getCartItemsIdByType(this.cart, 'GWP');
                        freeGiftIds = __spreadArrays(freeSamplesIds, gwpIds);
                        customCouponItem = this.getCustomCouponProductCartItem();
                        customCouponItemId = '';
                        if (customCouponItem) {
                            customCouponItemId = customCouponItem.id.toString();
                        }
                        if (!!threshold) return [3 /*break*/, 6];
                        if (!(freeGiftIds.length && !(freeGiftIds.length === 1 && freeGiftIds[0].toString() === customCouponItemId))) return [3 /*break*/, 6];
                        _i = 0, freeGiftIds_1 = freeGiftIds;
                        _f.label = 2;
                    case 2:
                        if (!(_i < freeGiftIds_1.length)) return [3 /*break*/, 5];
                        id = freeGiftIds_1[_i];
                        if (!(id.toString() !== customCouponItemId)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.cartService.remove(id)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 6:
                        if (!(customCouponItem && freeGiftIds.length > 1)) return [3 /*break*/, 11];
                        _a = 0, freeGiftIds_2 = freeGiftIds;
                        _f.label = 7;
                    case 7:
                        if (!(_a < freeGiftIds_2.length)) return [3 /*break*/, 10];
                        id = freeGiftIds_2[_a];
                        if (!(id.toString() !== customCouponItemId)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.cartService.remove(id)];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9:
                        _a++;
                        return [3 /*break*/, 7];
                    case 10:
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 11:
                        if (!(gwpIds.length > 1)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.cartService.remove(gwpIds.pop())];
                    case 12:
                        _f.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 13:
                        if (!(gwpIds.length > 0 && freeSamplesIds.length > 0)) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.cartService.remove(gwpIds[0])];
                    case 14:
                        _f.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 15:
                        if (!threshold) return [3 /*break*/, 17];
                        if (!(freeSamplesIds.length > threshold.numberOfFreeGifts)) return [3 /*break*/, 17];
                        return [4 /*yield*/, this.cartService.remove(freeSamplesIds[0])];
                    case 16:
                        _f.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 17:
                        reloadRequired = false;
                        _b = 0, _c = this.cart.items;
                        _f.label = 18;
                    case 18:
                        if (!(_b < _c.length)) return [3 /*break*/, 24];
                        cartItem = _c[_b];
                        if (!((cartItem.product_type === 'GWP' || cartItem.product_type === 'Sample') && customCouponItemId !== cartItem.id.toString())) return [3 /*break*/, 23];
                        itemThreshold = cartItem.properties._threshold;
                        if (!itemThreshold) return [3 /*break*/, 21];
                        if (!(itemThreshold.value > threshold.value)) return [3 /*break*/, 20];
                        return [4 /*yield*/, this.cartService.remove(cartItem.id)];
                    case 19:
                        _f.sent();
                        reloadRequired = true;
                        _f.label = 20;
                    case 20: return [3 /*break*/, 23];
                    case 21: return [4 /*yield*/, this.cartService.remove(cartItem.id)];
                    case 22:
                        _f.sent();
                        reloadRequired = true;
                        _f.label = 23;
                    case 23:
                        _b++;
                        return [3 /*break*/, 18];
                    case 24:
                        if (reloadRequired) {
                            this.isPageReloading = true;
                            return [2 /*return*/, window.location.reload()];
                        }
                        line = 1;
                        _d = 0, _e = this.cart.items;
                        _f.label = 25;
                    case 25:
                        if (!(_d < _e.length)) return [3 /*break*/, 29];
                        cartItem = _e[_d];
                        if (!((cartItem.product_type === 'GWP' || cartItem.product_type === 'Sample') && cartItem.quantity > 1)) return [3 /*break*/, 27];
                        data = {
                            line: line,
                            properties: cartItem.properties,
                            quantity: 1
                        };
                        return [4 /*yield*/, this.cartService.change(data)];
                    case 26:
                        _f.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 27:
                        line++;
                        _f.label = 28;
                    case 28:
                        _d++;
                        return [3 /*break*/, 25];
                    case 29: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.validateCartCustomCoupon = function () {
        return __awaiter(this, void 0, void 0, function () {
            var customCouponItem, response, coupon, isMinCartAmountValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customCouponItem = this.getCustomCouponProductCartItem();
                        if (!customCouponItem) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.storefrontService.get("custom-coupon/code/" + customCouponItem.properties._custom_coupon.code)];
                    case 1:
                        response = _a.sent();
                        coupon = response.data;
                        if (!coupon) {
                            return [2 /*return*/, false];
                        }
                        isMinCartAmountValid = this.coupons.isMinCartAmountValid(coupon);
                        if (isMinCartAmountValid) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.cartService.update([], [customCouponItem.id])];
                    case 2:
                        _a.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                }
            });
        });
    };
    Cart.prototype.validateCartCrossSellProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var crossSellProducts, isReloadRequired, _i, _a, item, isCrossSellItemAllowed, _b, crossSellProducts_1, crossSellProduct;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.crossSellProducts.get()];
                    case 1:
                        crossSellProducts = _c.sent();
                        isReloadRequired = false;
                        _i = 0, _a = this.cart.items;
                        _c.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        item = _a[_i];
                        if (item.product_type !== 'Cross-sell') {
                            return [3 /*break*/, 4];
                        }
                        isCrossSellItemAllowed = false;
                        for (_b = 0, crossSellProducts_1 = crossSellProducts; _b < crossSellProducts_1.length; _b++) {
                            crossSellProduct = crossSellProducts_1[_b];
                            if (item.handle === crossSellProduct.handle) {
                                isCrossSellItemAllowed = true;
                            }
                        }
                        if (!!isCrossSellItemAllowed) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.cartService.remove(item.id)];
                    case 3:
                        _c.sent();
                        isReloadRequired = true;
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        if (isReloadRequired) {
                            this.isPageReloading = true;
                            return [2 /*return*/, window.location.reload()];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.getCustomCouponProductCartItem = function () {
        for (var _i = 0, _a = this.cart.items; _i < _a.length; _i++) {
            var cartItem = _a[_i];
            if (!cartItem.properties) {
                continue;
            }
            var itemProperties = cartItem.properties;
            if (!itemProperties._custom_coupon) {
                continue;
            }
            //@ts-ignore
            if (itemProperties._custom_coupon) {
                return cartItem;
            }
        }
        return null;
    };
    Cart.prototype.handleFreeGifts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.freeGifts.appendPopup()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.freeGifts.appendSpendMoreElement()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.handleCrossSellProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.crossSellProducts.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.disableContinueBtn = function (value) {
        $(this.selectors.continueBtn).prop('disabled', value);
    };
    Cart.prototype.bindEvents = function () {
        var _this = this;
        var me = this;
        var $body = $(this.selectors.body);
        $(this.selectors.ajaxAddToCart).on('click', function (e) {
            e.preventDefault();
            var submitFormId = $(e.target).data('submit-form-id');
            $('#' + submitFormId).submit();
        });
        $body.on('click', this.selectors.addFreeGiftBtn, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.addFreeGiftsToCartFormHandle(e.target)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        $body.on('click', this.selectors.addProductBtn, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.addProductToCartFormHandle(e.target)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        $body.on('click', this.selectors.addSingleProductBtn, function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.addSingleProductToCartFormHandle(e.target)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cart.prototype.clearCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = {
                            updates: {},
                            attributes: {
                                properties: {}
                            },
                        };
                        return [4 /*yield*/, this.cartService.post(data)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.addFreeGiftsToCartFormHandle = function (target) {
        return __awaiter(this, void 0, void 0, function () {
            var $target, queryParams, addVariantIds, removeVariantIds, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $target = $(target);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        $target.prop('disabled', true);
                        queryParams = $(this.selectors.addProductToCartForm).serialize();
                        if (!queryParams) {
                            $target.prop('disabled', false);
                            return [2 /*return*/, this.showAddToCartError($target, 'Please select your gift')];
                        }
                        addVariantIds = this.mapFormValues($(this.selectors.addProductToCartForm));
                        removeVariantIds = common_helper_1.getCartFreeGiftIds(this.cart);
                        return [4 /*yield*/, this.cartService.update(addVariantIds, removeVariantIds, this.freeGiftsService.currentThreshold)];
                    case 2:
                        _a.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 3:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [2 /*return*/, this.showAddToCartError($target, 'Can not add product to the cart. Please try again')];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.showAddToCartError = function ($btn, msg) {
        var $error = $btn.siblings(this.selectors.cartFreeGiftsError);
        $error.text(msg);
        $error.show();
    };
    Cart.prototype.mapFormValues = function ($form) {
        return $form
            .serializeArray()
            .map(function (prop) { return prop.value; });
    };
    Cart.prototype.addProductToCartFormHandle = function (target) {
        return __awaiter(this, void 0, void 0, function () {
            var $form, addVariantIds, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        $(target).prop('disabled', true);
                        $form = $(target).closest('form');
                        addVariantIds = this.mapFormValues($form);
                        if (!addVariantIds.length) {
                            $(target).prop('disabled', false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.cartService.update(addVariantIds, [])];
                    case 1:
                        _a.sent();
                        window.location.reload();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        console.log(err_4);
                        return [2 /*return*/, alert('Error. Can not add product to the cart.')];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.addSingleProductToCartFormHandle = function (target) {
        return __awaiter(this, void 0, void 0, function () {
            var addVariantId, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        $(target).prop('disabled', true);
                        addVariantId = $(target).data('variant-id');
                        if (!addVariantId) {
                            $(target).prop('disabled', false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.cartService.update([addVariantId], [])];
                    case 1:
                        _a.sent();
                        window.location.reload();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        console.log(err_5);
                        return [2 /*return*/, alert('Error. Can not add product to the cart.')];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.handleCoupons = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isUpdateRequired;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.coupons.isUpdateRequired()];
                    case 1:
                        isUpdateRequired = _a.sent();
                        if (!isUpdateRequired) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.cartService.update([this.coupons.currentCoupon.options.variantId], [], null, this.coupons.currentCoupon)];
                    case 2:
                        _a.sent();
                        this.isPageReloading = true;
                        return [2 /*return*/, window.location.reload()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Cart;
}());
exports["default"] = Cart;
